import { objectiveToTarget } from '../ai/registry/properties';

export function normalizeParsedWithObjectives(parsed) {
  try {
    const p = JSON.parse(JSON.stringify(parsed || {}));
    const spec = p && p.generation_spec ? p.generation_spec : {};
    const objectives = Array.isArray(spec?.objectives) ? spec.objectives : [];
    const targets = Array.isArray(spec?.targets) ? spec.targets : [];
    if (objectives.length > 0 && targets.length === 0) {
      const mapped = objectives.map((o) => objectiveToTarget(o)).filter(Boolean);
      p.generation_spec.targets = mapped;
    }
    return p;
  } catch (_) {
    return parsed;
  }
}

/**
 * The legacy per-call budget-override key, `service::variant`, with an empty variant for a
 * call that has none (the router's FM4M calls carry `variant: null`). Pre-1a drafts and runs
 * stored their per-step budget edits under it; I9 made the key come from the router call,
 * never from a display label. Its one reader is rowsFromLegacyPlan
 * (src/ai/rows/legacyRows.js), which applies a legacy draft's or a legacy Re-run's stored
 * overrides to the rows it rebuilds.
 */
export function overrideKeyFor(service, variant) {
  return `${service}::${variant || ''}`;
}
